module.exports = __webpack_public_path__ + "static/media/follow_the_food_farmers_on_front_line_Desktop.2205f5c8.jpg";